export default __webpack_public_path__ + "static/media/antina_unde.8a7c56b2.png";